import GameBaseState from "./GameBaseState";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import { IStateType } from "./IGameState";
import { isGameHtml } from "@/js/utils";
import { Modal } from "ant-design-vue";
import IPCCenter from "@/js/ipc";
import { EVENTCMD } from "@/js/events";
import { useWsMessageStore } from "@/store/wsMessage";
import CheckGameingWindow from "@/js/checkGameingWindow";
export default class GameStateCanEnterGame extends GameBaseState {
  private playerStatusData;
  private wxMessage;
  private myType = IStateType.CAN_ENTER_GAME;
  constructor() {
    super();
    this.playerStatusData = this.playGameStore.playerStatusData;
    this.wxMessage = useWsMessageStore();
  }
  onPageReload() {
    Logger.log(`GameState ${IStateType[this.myType]} onPageReload`);

    const { node } = this.playerStatusData;
    Accounts.setCurrentGame(this.playerStatusData.gameNode!);
    node?.id && Accounts.setGameUid(node.id);
    node && Accounts.setCurrentGameNode(node);
    this.playGameStore.isQueueing = false;
    this.playGameStore.queueData = {
      ...this.playGameStore.queueData,
      playerOper: this.PLAYERSTATUS.NO_OPER,
      countDown: this.playerStatusData.enterGameCountdownTime,
    };

    if (!isGameHtml()) {
      Modal.destroyAll();
      this.playGameStore.showQueueModal({});
      IPCCenter.getInstance().broadCastEvent(EVENTCMD.StartCountDown, {});
    }
  }
  playGame() {
    Logger.log(`GameState CanEnterGame playGame`);
    this.playGameStore.handleOpenGame();
    // 进入游戏中状态
    this.setState(IStateType.CAN_RETURN_GAME);
  }

  async exitGame() {
    const exist = await CheckGameingWindow.checkIfExistGamingWindow();
    if (!exist) {
      Logger.log(`GameState CanEnterGame exit game`);
      this.playGameStore.handleGameExit();
      // 进入错过游戏状态
      this.setState(IStateType.MISS_ENTER_GAME);
    }
  }
  // 进入当前状态的操作
  onStateEnter() {
    const { node, enterGameCountdownTime } = this.wxMessage.wsMessageData;
    Accounts.setGameUid(node.id);
    Accounts.setCurrentGameNode(node);
    this.playGameStore.showQueueModal({
      playerOper: this.PLAYERSTATUS.NO_OPER,
      countDown: enterGameCountdownTime,
    });
    IPCCenter.getInstance().broadCastEvent(EVENTCMD.StartCountDown, {});
  }
}
